module.exports = __webpack_public_path__ + "static/img/xsyzc2x-D3aQCj_P.f19fe12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/xsyzc2x-D3aQCj_P.png
// module id = /Qdu
// module chunks = 16